// pages/career/apply.jsx
import { useState ,useEffect } from "react";
import Head from "next/head";
import { getJobs } from "../../lib/getJobs";
import JobAccordion from "../../components/career/JobAccordion";
import dynamic from "next/dynamic";
import Footer from "../../components/Footer";
const Navbar = dynamic(() => import("../../components/Navbar"), { ssr: false });
import { Globe, Users, Award } from "lucide-react";
import { useRouter } from "next/router";

export default function ApplyPage({ jobs }) {
  const router = useRouter();
  const [selectedCategory, setSelectedCategory] = useState("all");

  useEffect(() => {
    // Apply initial category from query string
    if (router.query.category) {
      setSelectedCategory(router.query.category.toLowerCase());
    }
  }, [router.query.category]);

  const categories = ["all", ...new Set(jobs.map((job) => job.category).filter(Boolean))];
  const filteredJobs = selectedCategory === "all"
    ? jobs
    : jobs.filter((job) => job.category === selectedCategory);

  return (
    <>
      <Navbar />
      <Head>
        <title>Apply | Careers at ITMTB</title>
        <meta
          name="description"
          content="Explore open roles at ITMTB and apply to become part of our innovative team."
        />
      </Head>

      {/* Hero Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white mt-16">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl font-normal text-gray-900 mb-6">Build the Future with Us</h1>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Join a team of innovators, dreamers, and builders who are reshaping industries through cutting-edge technology and human-centered design.
          </p>
          <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-500">
            <div className="flex items-center gap-2">
              <Globe className="w-4 h-4" />
              <span>Remote-First Culture</span>
            </div>
            <div className="flex items-center gap-2">
              <Users className="w-4 h-4" />
              <span>Supportive Team Members</span>
            </div>
            <div className="flex items-center gap-2">
              <Award className="w-4 h-4" />
              <span>Best Places to Work</span>
            </div>
          </div>
        </div>
      </section>
      <hr className="border-orange/80 max-w-2xl mx-auto" />
      {/* Jobs Section */}
      <section className="pt-16 pb-16 bg-gray-50 min-h-screen">
        <div className="max-w-5xl mx-auto px-4">
          <h2 className="text-3xl sm:text-4xl font-normal text-center mb-10 text-black">Explore Opportunities at ITMTB</h2>

          {/* Category Filter Buttons */}
          <div className="flex flex-wrap justify-center gap-3 mb-6">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setSelectedCategory(cat)}
                className={`px-4 py-2 rounded-full border transition ${
                  selectedCategory === cat
                    ? "bg-orange text-white border-orange"
                    : "bg-white text-gray-700 border-gray-300 hover:border-orange"
                }`}
              >
                {cat.charAt(0).toUpperCase() + cat.slice(1)}
              </button>
            ))}
          </div>

          {/* Filtered Job List */}
          <JobAccordion jobs={filteredJobs} />
        </div>
      </section>

      <Footer />
    </>
  );
}

export async function getStaticProps() {
  const jobs = getJobs(); // no changes needed here
  return { props: { jobs } };
}
